import React, { Component } from 'react';
import { connect } from 'react-redux';

import CaseStatusTrackerPres from './CaseStatusTrackerPres';

class CaseStatusTrackerContainer extends Component {
  state = {
    phases: [],
  };
  static defaultProps = {
    showPhaseLabel: false,
  };

  componentDidMount() {
    if (this.props != null) {
      let phases = this.props.caseStages;
      this.setState({ phases: phases });
    }
  }

  componentDidUpdate() {}

  componentWillUnmount() {
    this.setState({ phases: [] });
  }

  render() {
    return <CaseStatusTrackerPres showPhaseLabel={this.props.showPhaseLabel} phases={this.state.phases} />;
  }
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(CaseStatusTrackerContainer);
